module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "song-search hero is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control has-icons-left has-icons-right",
    class: {
      'is-loading': false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        return _vm.clearFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-right clickable"
  }, [(_vm.filter) ? _c('a', {
    staticClass: "delete",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilter()
      }
    }
  }) : _vm._e()])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "song-list"
  }, _vm._l((_vm.songs), function(song) {
    return _c('div', {
      key: song.id,
      staticClass: "song is-fullwidth",
      on: {
        "click": function($event) {
          return _vm.showSong(song)
        }
      }
    }, [_c('div', {
      staticClass: "container"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', {
      staticClass: "list-element-title"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(song.title)
      }
    })])])])])
  }), 0), _vm._v(" "), _c('BaseRouterRoundButton', {
    attrs: {
      "destination": _vm.addLink
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b1a8b46!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Songs.vue
// module id = 313
// module chunks = 2